import { useState, useEffect, useMemo } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import ecpCurl, { asyncAll } from '@lcsc-ui/utils/ecpCurl';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import StaticdataApi, { resourceCatalogList } from '@/apis/staticdata';
import SmtPage from '@/features/smtPage';

const Index = ({ resourceData, websiteSectionList, headerAd }) => {
  const [catalogList, setCatalogList] = useState(null);

  useEffect(() => {
    resourceCatalogList().then((res) => {
      setCatalogList(res?.result);
    });
  }, []);

  const env = process.env.NEXT_PUBLIC_APP_ENV;

  const seo = useMemo(() => {
    return {
      title: `嘉立创PCB/SMT在线下单入口-PCB免费打样-立创商城`,
      description: `立创商城提供嘉立创PCB打样和SMT贴片下单入口，PCB业务涵盖打样、批量以及高多层板业务，支持免费打样，全国包邮，批量低至210元/㎡起。SMT贴片服务低至50元起，还享元器件专享价。PCB+SMT最快仅需24小时发货。`,
      additionalMetaTags: [
        {
          name: 'keywords',
          content: `嘉立创PCB,嘉立创SMT,立创PCB,嘉立创PCB下单入口`,
        },
      ],
    };
  }, []);

  return (
    <>
      <NextSeo {...seo}></NextSeo>
      <Head>
        <link rel="canonical" href={`https://${env === 'pro' ? '' : env}smt.szlcsc.com`} />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        notIndexHeaderAdapter={true}
        onlySScreen={true}
        isLgScreen={false}
        isNeedTopAd={false}
        isShowBottomAd={false}
      >
        <SmtPage />
        <Toolbar></Toolbar>
      </BaseLayout>
    </>
  );
};
export async function getStaticProps() {
  const [resourceData, websiteSectionList, headerAd, notFound] = await asyncAll([
    ecpCurl(StaticdataApi.resourceList),
    ecpCurl(StaticdataApi.websiteSection),
    ecpCurl(StaticdataApi.advertisingHeader),
  ]);

  if (notFound) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      resourceData,
      websiteSectionList,
      headerAd,
    },
  };
}

export default Index;
